"use strict";

import * as CryptoJS from "crypto-js";
import jsSHA from "jssha";
import axios from "axios";
import { Global } from "./global";
import { getCookie, setCookie } from "./util";

const BASE_URL = "https://bigcityapps.in/heineken/football/api/";
const defaultHeaders = {
  Accept: "*/*",
  "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
};

const userKey = localStorage.getItem("userKey");
async function createUser() {
  try {
    const masterKey = getCookie("hf-id");
    const formData = new URLSearchParams();

    if (masterKey) formData.append("masterKey", masterKey);

    const urlParams = new URLSearchParams(window.location.search);
    const utmKeys = [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_content",
      "utm_term",
    ];

    utmKeys.forEach((key) => {
      const value = urlParams.get(key);
      if (value) formData.append(key, value);
    });

    const headers = { ...defaultHeaders };

    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      headers.Authorization = `Bearer ${accessToken}`;
    }

    const res = await axios.post(`${BASE_URL}users`, formData.toString(), {
      headers,
    });

    const decodedData = JSON.parse(window.atob(res.data.resp));

    if (decodedData?.statusCode === 200) {
      setCookie("hf-id", decodedData.userKey);
      localStorage.setItem("userKey", decodedData.userKey);
      localStorage.setItem("dataKey", decodedData.dataKey);
    }

    console.log(decodedData);
    return decodedData;
  } catch (error) {
    console.error("Error creating user:", error);
    return null;
  }
}

async function clickUpdator(isPostAction, type) {
  const dataKey = localStorage.getItem("dataKey");
  const userKey = localStorage.getItem("userKey");

  const data = {
    userKey,
    type,
  };
  const encryptedData = encryptData(data, dataKey);
  const obj = {
    userKey,
    data: encryptedData,
  };
  try {
    const accessToken = String(localStorage.getItem("accessToken"));
    const headers = {
      ...defaultHeaders,
    };
    if (isPostAction && accessToken) {
      headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const res = await axios.post(
      `${BASE_URL}users/${isPostAction ? "post-action" : "action"}/${userKey}`,
      new URLSearchParams(obj),
      {
        headers: {
          ...headers,
        },
      }
    );

    return JSON.parse(window.atob(res.data.resp));
  } catch (err) {
    return JSON.parse(window.atob(err.response.data.resp));
  }
}

async function getStates() {
  const userKey = localStorage.getItem("userKey");

  const res = await axios.get(`${BASE_URL}users/getStates/${userKey}`);
  const stateRes = JSON.parse(window.atob(res.data.resp));
  return stateRes.stateData;
}

async function register(name, email, mobile, state) {
  const dataKey = localStorage.getItem("dataKey");
  const userKey = localStorage.getItem("userKey");
  const data = {
    userKey,
    name,
    email,
    mobile,
    state,
  };
  const encryptedData = encryptData(data, dataKey);
  const obj = {
    userKey,
    data: encryptedData,
  };
  const params = new URLSearchParams(obj);
  try {
    const res = await axios.post(
      `${BASE_URL}users/register/${userKey}`,
      params,
      {
        headers: {
          ...defaultHeaders,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );
    return JSON.parse(window.atob(res.data.resp));
  } catch (err) {
    return JSON.parse(window.atob(err.response.data.resp));
  }
}

async function resendOTP() {
  const dataKey = localStorage.getItem("dataKey");
  const userKey = localStorage.getItem("userKey");

  const data = {
    userKey,
  };
  const encryptedData = encryptData(data, dataKey);
  const obj = {
    userKey,
    data: encryptedData,
  };
  const params = new URLSearchParams(obj);
  try {
    const res = await axios.post(
      `${BASE_URL}users/resendOtp/${userKey}`,
      params,
      {
        headers: {
          ...defaultHeaders,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );
    return JSON.parse(window.atob(res.data.resp));
  } catch (err) {
    return JSON.parse(window.atob(err.response.data.resp));
  }
}
async function verifyOTP(otp) {
  const dataKey = localStorage.getItem("dataKey");
  const userKey = localStorage.getItem("userKey");

  const data = {
    userKey,
    otp,
  };
  const encryptedData = encryptData(data, dataKey);
  const obj = {
    userKey,
    data: encryptedData,
  };
  const params = new URLSearchParams(obj);
  try {
    const res = await axios.post(
      `${BASE_URL}users/verifyOTP/${userKey}`,
      params,
      {
        headers: {
          ...defaultHeaders,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );
    return JSON.parse(window.atob(res.data.resp));
  } catch (err) {
    return JSON.parse(window.atob(err.response.data.resp));
  }
}
async function saveScore(score, time, key1, key2) {
  const dataKey = localStorage.getItem("dataKey");
  const gameKey = localStorage.getItem("gameKey");
  const userKey = localStorage.getItem("userKey");

  const data = {
    userKey,
    gameKey,
    score,
    time,
    key1,
    key2,
  };
  const encryptedData = encryptData(data, dataKey);
  const obj = {
    userKey,
    data: encryptedData,
  };
  const accessToken = String(localStorage.getItem("accessToken"));
  const headers = {
    ...defaultHeaders,
  };
  headers["Authorization"] = `Bearer ${accessToken}`;
  const params = new URLSearchParams(obj);
  try {
    const res = await axios.post(
      `${BASE_URL}users/saveScore/${userKey}`,
      params,
      {
        headers: {
          ...headers,
        },
      }
    );
    return JSON.parse(window.atob(res.data.resp));
  } catch (err) {
    return JSON.parse(window.atob(err.response.data.resp));
  }
}

async function getLeader(weekNo) {
  const dataKey = localStorage.getItem("dataKey");
  const userKey = localStorage.getItem("userKey");

  const data = {
    userKey,
    weekNo,
  };
  const encryptedData = encryptData(data, dataKey);
  const obj = {
    userKey,
    data: encryptedData,
  };
  const accessToken = String(localStorage.getItem("accessToken"));
  const headers = {
    ...defaultHeaders,
  };
  headers["Authorization"] = `Bearer ${accessToken}`;
  const params = new URLSearchParams(obj);
  try {
    const res = await axios.post(
      `${BASE_URL}users/leaderboard/${userKey}`,
      params,
      {
        headers: {
          ...headers,
        },
      }
    );
    return JSON.parse(window.atob(res.data.resp));
  } catch (err) {
    return JSON.parse(window.atob(err.response.data.resp));
  }
}

function encryptData(data, dataKey) {
  const t = new Date().getTime();
  data.t = t;
  const dAr = CryptoJS.enc.Utf8.parse(JSON.stringify(data));
  const dr = CryptoJS.enc.Base64.stringify(dAr);
  const hd = CryptoJS.enc.Base64.stringify(
    CryptoJS.enc.Utf8.parse(t.toString())
  );
  const shaObj = new jsSHA("SHA-256", "TEXT");
  shaObj.setHMACKey(dataKey.substr(4, 14), "TEXT");
  shaObj.update(hd + "." + dr);
  const hmac = shaObj.getHMAC("HEX");
  const k1 = CryptoJS.enc.Utf8.parse(hmac);
  const k2 = CryptoJS.enc.Base64.stringify(k1);
  let text = "";
  const possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const r1 = Math.floor(Math.random() * 6) + 1;
  const r2 = Math.floor(Math.random() * 7) + 2;
  for (let i = 0; i < r2; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  const f_str = String(r2) + String(r1) + k2.slice(0, r1) + text + k2.slice(r1);
  const out = hd + "." + dr + "." + f_str;
  return out;
}
export {
  createUser,
  clickUpdator,
  getStates,
  register,
  resendOTP,
  verifyOTP,
  saveScore,
  getLeader,
};
